// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"Transportation_sectionTitle__vRIb_","sectionIcon":"Transportation_sectionIcon__VpuAU"};